<ng-template>
  <div class="p-[12px_18px_18px_18px] gap-2 rounded-lg shadow-custom1 bg-white">
    <div class="flex justify-end items-center">
      <button (click)="closePopover()" class=" ">
        <ng-icon name="heroXMark" class="relative" size="20"></ng-icon>
      </button>
    </div>

    <ng-content></ng-content>
  </div>
</ng-template>
